import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
export const Space = ({ size }) => {
    return (_jsx(Flex, { ...(size === 'fill'
            ? {
                flex: '1',
            }
            : {
                flexBasis: size,
                flexShrink: 0,
            }) }));
};
